<template>
  <b-card>
      <!-- Form -->
      <b-form
        class="p-2"
      >
      <validation-observer
        ref="accountRules"
        tag="form"
      >
        <b-row class="mt-1" v-for="(item, index) in rowData.dosen_penguji" :key="item.id" style="margin-bottom: 20px;">
            <b-col md="6">
              <b-form-group>
                <label for="">Dosen Penguji {{ index += 1 }} <span style="color: red; font-size: 16px;">*</span></label>
                   <v-select
                    id="dosen_penguji_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="item.dosen_uuid"
                    placeholder="Pilih Dosen Penguji"
                  />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="">Penguji Utama ?<span style="color: red; font-size: 16px;">*</span></label>
                   <v-select
                    id="dosen_penguji"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenUtamaOption.options"
                    v-model="item.penguji_utama"
                    placeholder="Pilih"
                  />
              </b-form-group>
            </b-col>
            <b-col md="1">
              <div class="d-flex justify-content-begin">
                <b-button @click="deletePenguji(item.uuid)" variant="outline-danger" style="margin-top:27px; margin-right: 10px;"><feather-icon icon="TrashIcon" /></b-button>
              </div> 
            </b-col>
          </b-row>
          
        <b-row>
            <b-col md="6">
                <b-form-group>
                  <label for="">Apakah perubahan ini sudah diketahui oleh pembimbing dan penguji?<span style="color: red; font-size: 16px;">*</span></label>
                  <validation-provider
                    #default="{ errors }"
                    name="persetujuan_perubahan"
                  >
                    <v-select
                      id="persetujuan_perubahan"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :reduce="val => val.value"
                      :options="jawabanPersetujuanOption.options"
                      v-model="rowData.persetujuan_perubahan"
                      placeholder="Pilih Jawaban"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            @click="updateData"
            :disabled="rowData.status_jadwal_sidang_id == 2 || rowData.status_jadwal_sidang_id == 3"
          >
            Simpan
          </b-button>
        </div>
      </validation-observer>
      </b-form>
      <div>
        <b-modal id="modal-center-loading" centered title="Loading" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close v-if="showModal === 1">
          <div v-if="this.error_check.length == 0">
            <div class="d-flex justify-content-center mt-2">
              <b-spinner
              :variant="'dark'"
              ></b-spinner>
            </div>
            <div class="d-flex justify-content-center mt-2">
            Loading....
            </div>
          </div>
          <div v-else>
            <div class="d-flex justify-content-center mt-2">
              <h4 style="color:red;">Gagal Memuat Data</h4>
            </div>
          </div>
          <b-button class="mt-3" block @click="reload()" variant="primary">Muat Ulang</b-button>
        </b-modal>
      </div>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BAvatar, BRow, BCol, BBadge,
  BForm, BFormGroup, BFormInput, BFormInvalidFeedback,
  BFormSpinbutton, BFormTextarea, BFormDatepicker, BModal, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { required, alphaNum, email } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import { avatarText } from '@core/utils/filter'
import useList from '@/connection-api/jenis-dokumen/list'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import {
  getRuangan,
  getDetailJadwalSidang,
  getWaktuUjian,
  updateJadwalSidang,
} from '@/connection-api/master'
require('moment/locale/id');

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BButton,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormDatepicker,
    vSelect,
    BModal,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      error_check: [],
      success_check: [],
      showModal: 0,
      rowData: {},
      required,
      alphaNum,
      email,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
      waktuUjianOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Waktu Ujian --' },
        ],
      },
      ruanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Ruangan --' },
        ],
      },
      dosenOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Dosen --' },
        ],
      },
      jawabanPersetujuanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jawaban --' },
          { value: 'ya', title: 'Ya' },
          { value: 'tidak', title: 'Tidak' },
        ],
      },
      dosenUtamaOption: {
        selected: 'id',
        options: [
          { value: null, title: 'Pilih' },
          { value: 'ya', title: 'Ya' },
          { value: "tidak", title: 'Tidak' },
        ],
      },
    }
  },
  mounted() {
    this.$bvModal.show('modal-center-loading')
    getDetailJadwalSidang(this.$route.params.uuid)
      .then(response => {
        this.rowData = response.data.data;
        if(this.rowData.dosen.length > 0)
        {
          this.buildOption(this.rowData.dosen, this.dosenOption)
        }
        this.success_check.push('success')
        this.completeCheck()
      })
    .catch(error => {
      this.error_check.push(error)
    });
    this.getRuanganF()
    this.getWaktuF()
  },
  methods: {
    buildOption(data, option) {
      data.forEach(element => {
        option.options.push({
          title: element.nama,
          value: element.uuid,
        })
      })
    },
    completeCheck()
    {
      if(this.success_check.length == 2 && this.error_check.length == 0)
      {
        this.showModal = 0
      }
    },
    getRuanganF() {
      getRuangan()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.ruanganOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        this.success_check.push('success')
        this.completeCheck()
      }
      })
      .catch(error => {
        console.log(error)
        this.getRuanganF()
      });
    },
    getWaktuF() {
      getWaktuUjian()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.waktuUjianOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        this.success_check.push('success')
        this.completeCheck()
      }
      })
      .catch(error => {
        this.getWaktuF()
      });
    },
    updateData() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            this.rowData.flag = 'update_dosen_penguji'
            var params = {
              id: this.$route.params.uuid,
              params: this.rowData,
            }
            updateJadwalSidang(params)
            .then(response => {
            if (response.data.success == true) {
              this.makeToast('success', 'Data berhasil disimpan')
              setTimeout(() => {
                this.$router.push({name: 'jadwal-sidang'})
              }, 2000);
              this.success_check.push('success')
              this.completeCheck()
              resolve(true)
            } else {
              reject()
              this.makeToast('danger', response.data.message)
            }
            })
            .catch(error => {
              console.log(error)
            });
          } else {
            reject()
          }
        })
      })
    },
    formatPrice(value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate(value, format) {
      moment.locale('id');
      return moment(String(value)).format(format)
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Jadwal Sidang',
        variant,
        solid: true,
        autoHideDelay: 4000,
      })
    },
  },
}
</script>

<style>

</style>
